Controller = App.loadClass 'core::Angular/Controller'

class exports.QBQController extends Controller
    constructor: (@scope, @transitions, @service, @interval) ->
        # This page doesn't use the sidebar
        App.sidebar?.close()
        App.angularSidebar?.close()

        @scope.title = 'QBQ'
        @scope.fullpage = true
        @scope.absolute_errors = true
        @scope.showTooManyItemsMessage = false

        # Instance data
        @scope.choice = ''
        @scope.queueItems = []
        @scope.extra =
            orders: ''
        @scope.progressBars =
            success: 0
            danger: 0

        @scope.triggerButtonDisabled = true

        # Scope functions
        @scope.trigger = (choice, extra) =>
            # Disabling the trigger button until the queue is refreshed
            # to prevent accidental duplicates
            @scope.triggerButtonDisabled = true
            @service.triggerSync(choice, extra)

        # Load data
        @fetchData()
        interval = @interval @fetchData, 2000

        @scope.$on '$destroy', () =>
            @interval.cancel interval

    fetchData: () =>
        @service.getQueueData().then (result) =>
            @scope.queueItems = result.data

            numSuccess = 0
            numError = 0
            numQueued = 0

            for queueItem in result.data
                if queueItem.s is 's'
                    numSuccess += 1
                else if queueItem.s is 'e'
                    numError += 1
                else if queueItem.s is 'q'
                    numQueued += 1

            @scope.progressBars['success'] = parseInt(100 * parseFloat(numSuccess) / result.data.length + 0.5)
            @scope.progressBars['danger'] = parseInt(100 * parseFloat(numError) / result.data.length + 0.5)

            # Only reenable it when the sync is finished
            if numQueued is 0
                @scope.triggerButtonDisabled = false
            else
                @scope.triggerButtonDisabled = true
